import { render, staticRenderFns } from "./WalletParentStatisticalDialog.vue?vue&type=template&id=ed851c0e&scoped=true"
import script from "./WalletParentStatisticalDialog.vue?vue&type=script&lang=js"
export * from "./WalletParentStatisticalDialog.vue?vue&type=script&lang=js"
import style0 from "./WalletParentStatisticalDialog.vue?vue&type=style&index=0&id=ed851c0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed851c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed851c0e')) {
      api.createRecord('ed851c0e', component.options)
    } else {
      api.reload('ed851c0e', component.options)
    }
    module.hot.accept("./WalletParentStatisticalDialog.vue?vue&type=template&id=ed851c0e&scoped=true", function () {
      api.rerender('ed851c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Wallet/WalletParentStatisticalDialog.vue"
export default component.exports